import { AbstractHoverZone } from './AbstractHoverZone';
import React from 'react';
import { AbstractHoverZoneBidirectional } from './AbstractHoverZoneBidirectional';
import { WithAbstractHoverZoneProps } from './types';

export const WithAbstractHoverZone = <D,>({
  tooltipY,
  setTooltipY,
  getTooltipData,
  isBidirectional,
  children,
  ...rest
}: WithAbstractHoverZoneProps<D>) =>
  isBidirectional ? (
    <AbstractHoverZoneBidirectional<D>
      getTooltipData={getTooltipData}
      tooltipY={tooltipY}
      setTooltipY={setTooltipY}
      {...rest}
    >
      {children}
    </AbstractHoverZoneBidirectional>
  ) : (
    <AbstractHoverZone<D> {...rest}>{children}</AbstractHoverZone>
  );
